import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HelpSection = () => {
  const helpItems = [
    {
      icon: "LifeBuoy",
      title: "Need Help?",
      description: "Access our comprehensive FAQ and support documentation",
      action: "View FAQs",
      color: "text-primary",
      bgColor: "bg-primary/10"
    },
    {
      icon: "MessageSquare",
      title: "Chat Support",
      description: "Our team is available Monday-Friday, 9AM-5PM WAT",
      action: "Start Chat",
      color: "text-accent",
      bgColor: "bg-accent/10"
    },
    {
      icon: "Phone",
      title: "Call Us",
      description: "Speak directly with our onboarding specialists",
      action: "08025458124",
      color: "text-secondary",
      bgColor: "bg-secondary/10"
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 1.2 }}
      className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-2xl p-8 border border-border"
    >
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-foreground mb-2">We're Here to Help</h2>
        <p className="text-muted-foreground">Get assistance at any step of your onboarding journey</p>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {helpItems?.map((item, index) => (
          <div key={index} className="bg-card rounded-xl p-6 border border-border text-center">
            <div className={`w-14 h-14 ${item?.bgColor} rounded-xl flex items-center justify-center mx-auto mb-4 ${item?.color}`}>
              <Icon name={item?.icon} size={28} className={item?.color} />
            </div>
            <h3 className="font-semibold text-foreground mb-2">{item?.title}</h3>
            <p className="text-sm text-muted-foreground mb-4">{item?.description}</p>
            <Button variant="outline" size="sm" fullWidth>
              {item?.action}
            </Button>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default HelpSection;